import { DeleteButton, EditButton, List, useTable } from "@refinedev/antd";
import { Space, Table, Tag, Tooltip } from "antd";
import { IconDisplay } from "../../components/IconDisplay";

export function CardTemplatesList() {
  const { tableProps } = useTable({
    resource: "card-template",
    syncWithLocation: true,
    queryOptions: { keepPreviousData: false, cacheTime: 0, staleTime: 0 },
    meta: { headers: { "Cache-Control": "no-cache", Pragma: "no-cache" } },
  });

  const columns = [
    {
      title: "Image",
      dataIndex: "displayImageURL",
      render: (url: string) => (
        <IconDisplay iconURL={url} width={40} height={48} borderRadius="6px" />
      ),
    },
    { title: "Title", dataIndex: "title" },
    { title: "Description", dataIndex: "description" },
    {
      title: "Colour",
      dataIndex: "primaryColor",
      render: (hex: string) => (
        <Space>
          <span
            style={{
              display: "inline-block",
              width: 16,
              height: 16,
              borderRadius: 4,
              background: hex,
              border: "1px solid rgba(0,0,0,0.15)",
            }}
          />
          <span>{hex}</span>
        </Space>
      ),
    },
    {
      title: "Fillable",
      dataIndex: "fillableSvgURL",
      render: (url: string | null) =>
        url ? <Tag color="green">SVG</Tag> : <Tag>—</Tag>,
    },
    {
      title: "XP unlock",
      dataIndex: "xpThreshold",
      render: (xp: number) => `${xp ?? 0} XP`,
    },
    { title: "Priority", dataIndex: "priority" },
    {
      title: "Active",
      dataIndex: "isActive",
      render: (active: boolean) =>
        active ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
    },
    {
      title: "Actions",
      render: (_: any, record: any) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record.id} />
          <Tooltip title="In-use templates can't be deleted — deactivate instead.">
            <DeleteButton hideText size="small" recordItemId={record.id} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: "4px" }}>
      <List>
        <Table {...tableProps} columns={columns} rowKey="id" />
      </List>
    </div>
  );
}
